import { axiosConfig } from './axios-config.js'

export const image = {
  // 上傳圖片
  update: (data, token) => axiosConfig.post('/api/console/image', data, token)
}
